export const jsonToBase64 = (json: any): string => {
    const jsonString = JSON.stringify(json);
    return btoa(jsonString);
};
